// Android screen control

var Model = require("../types/Model.js");
var window = require("global");
var BackgroundCheckModule = require("react-native-background-check");

var doErr = console.error.bind(console);

module.exports = Model({
	name: "screenlocker",
	listeners: listeners,
	triggers: triggers,
	uninit: uninit,

	unlock: unlock
});

function listeners(){
	return {
		"mqtt:$/app/lock": lock,
		"mqtt:$/app/unlock": unlock
	};
}

function triggers() {
	return {
		lock: lock,
		unlock: unlock
	};
}

function uninit() {
	this.unlock();
}

function lock() {
	var plugin = getPlugin();
	if (plugin){
		plugin.lockScreen(handle_locked.bind(this), doErr);
	}
	if(BackgroundCheckModule){
		BackgroundCheckModule.lightScreen();
	}
}

function unlock() {
	var plugin = getPlugin();
	if (plugin){
		plugin.unlockScreen(handle_unlocked.bind(this), doErr);
	}
	if(BackgroundCheckModule){
		BackgroundCheckModule.clearWindow();
	}
}

function handle_locked() {
	this.dispatch("locked");
	this.api.people.app.lock();
}

function handle_unlocked() {
	this.dispatch("unlocked");
	this.api.people.app.unlock();
}

function getPlugin() {
	return window && window.plugins && window.plugins.aetonixapplock;
}
